import React from 'react';

import { useNavigate } from 'react-router-dom';

import Logo from '#/assets/images/logo-h.png';
import {
    Avatar,
    AvatarFallback,
    AvatarImage,
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
} from '#/components/ui';
import { useAppContext } from '#/context';
import { ROUTES } from '#/routes';
import { ACCESS_TOKEN, cn, NAVBAR_HEADERS, removeLocalStorageItem, removeSessionStorageItem } from '#/utils';
import { GlobalSearch } from '.';

const Header = () => {
    const { user } = useAppContext();

    const { firstName, lastName, profilePicture } = user || {};

    const navigate = useNavigate();

    const handleLogout = () => {
        removeLocalStorageItem(ACCESS_TOKEN);
        removeSessionStorageItem(ACCESS_TOKEN);
        navigate(ROUTES.LOGIN);
    };

    const handleNavigation = {
        goHome: () => navigate(ROUTES.HOME),
        goProfile: () => navigate(ROUTES.PROFILE),
        goContacts: () => navigate(ROUTES.MY_CONTACTS),
        logout: handleLogout,
    };

    return (
        <div className='flex justify-between h-[82px] items-center py-4 px-14 bg-white '>
            <img src={Logo} alt='hill&co' className='w-[172px] cursor-pointer' onClick={handleNavigation['goHome']} />

            <GlobalSearch />
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Avatar className='cursor-pointer w-12 h-12'>
                        <AvatarImage
                            src={profilePicture}
                            alt={firstName}
                            className='w-full h-full object-cover rounded-full object-top'
                        />
                        <AvatarFallback className='bg-gray-200 text-gray-500'>
                            {firstName?.charAt(0)}
                            {lastName?.charAt(0)}
                        </AvatarFallback>
                    </Avatar>
                </DropdownMenuTrigger>

                <DropdownMenuContent align='end' className='w-48 bg-white '>
                    {NAVBAR_HEADERS.map(item => {
                        const Icon = item.icon;
                        return (
                            <DropdownMenuItem
                                key={item.id}
                                onClick={handleNavigation[item.action]}
                                className={cn(
                                    'cursor-pointer flex items-center gap-2 hover:bg-gray50 outline-none focus:outline-none',
                                    item.className
                                )}
                            >
                                {Icon && <Icon className='w-4 h-4 text-gray700' />}
                                <span className='text-sm text-gray700 font-normal'>{item.label}</span>
                            </DropdownMenuItem>
                        );
                    })}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

export { Header };
